import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useRouter} from "vue-router";
import {notification} from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {


const router = useRouter()
const toHome = () => {
  router.push({path: '/'}).catch(err => notification.error({message: err}))
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_result = _resolveComponent("a-result")!

  return (_openBlock(), _createBlock(_component_a_result, {
    status: "404",
    title: "404",
    "sub-title": "找不到此页面"
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: toHome
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 返回首页 ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})